import { OptionModel } from '@/lib/models/option/types';

export const calcArrivalReliability = (options: OptionModel[]): number => {
  let count = 0;
  const summedReliability = options.reduce((accum, option) => {
    if (option.arrivalOtp) {
      count += 1;
      return accum + option.arrivalOtp;
    }
    return accum;
  }, 0);

  return summedReliability ? summedReliability / count : 0;
};
